import type { CorrectType } from '@repo/types/quiz';

export const getCorrectTypeColor = (correctState: CorrectType) => {
  switch (correctState) {
    case true:
      return 'text-text-success';
    case false:
      return 'text-text-destructive';
    case null:
      return 'text-text-secondary';
    case 'partially':
      return 'text-text-warning';
    case 'waiting':
      return 'text-text-tertiary';
  }
};
